import { Navigate, Route, Routes } from 'react-router-dom';

import AboutTab from 'pages/GetCertified/Tabs/AboutTab/AboutTab';
import ApplyTab from 'pages/GetCertified/Tabs/ApplyTab/ApplyTab';
import BillingAndPaymentTab from 'pages/Profile/Tabs/BillingAndPaymentTab/BillingAndPaymentTab';
import CertificateTab from 'pages/GetCertified/Tabs/CertificateTab/CertificateTab';
import ClassesTab from 'pages/Organization/Tabs/ClassesTab/ClassesTab';
import CookiePolicyPage from 'pages/Policies/CookiePolicyPage/CookiePolicyPage';
import CourseList from 'pages/Admin/Courses/CourseList/CourseList';
import EditCourse from 'pages/Admin/Courses/EditCourse/EditCourse';
import EditLearningMaterial from 'pages/Admin/LearningMaterials/EditLearningMaterial/EditLearningMaterial';
import EditLesson from 'pages/Admin/Lessons/EditLesson/EditLesson';
import EditMaster from 'pages/Admin/Masters/EditMaster/EditMaster';
import EditOrganization from 'pages/Admin/Organizations/EditOrganization/EditOrganization';
import EditPartner from 'pages/Admin/Partners/EditPartner/EditPartner';
import EditStudyCourse from 'pages/Admin/StudyCourses/EditStudyCourse/EditStudyCourse';
import EditStudyLesson from 'pages/Admin/StudyLessons/EditStudyLesson/EditStudyLesson';
import EditTrackmanParameter from 'pages/Admin/TrackmanParameters/EditTrackmanParameter/EditTrackmanParameter';
import EventEditor from 'pages/Admin/Events/EventEditor/EventEditor';
import EventsList from 'pages/Admin/Events/EventsList/EventsList';
import GetCertified from 'pages/GetCertified/GetCertified';
import HomePage from 'pages/HomePage/HomePage';
import { LandingPage } from './pages/LandingPage/LandingPage';
import LearningMaterials from 'pages/LearningMaterials/LearningMaterials';
import LearningMaterialsLessonPage from 'pages/LearningMaterials/LearningMaterialsLessonPage/LearningMaterialsLessonPage';
import LearningMaterialsList from 'pages/Admin/LearningMaterials/LearningMaterialsList/LearningMaterialsList';
import LessonList from 'pages/Admin/Lessons/LessonList/LessonList';
import ManageUserData from 'pages/Admin/ManageUserData/ManageUserData';
import MastersList from 'pages/Admin/Masters/MastersList/MastersList';
import MastersTab from 'pages/GetCertified/Tabs/MastersTab/MastersTab';
import ModulesAndTests from 'pages/ModulesAndTests/ModulesAndTests';
import ModulesAndTestsItem from 'pages/ModulesAndTests/ModulesAndTestsItem/ModulesAndTestsItem';
import NoAccess from 'pages/ErrorPages/NoAccess/NoAccess';
import NotFound from 'pages/ErrorPages/NotFound/NotFound';
import Organization from 'pages/Organization/Organization';
import OrganizationsList from 'pages/Admin/Organizations/OrganizationsList/OrganizationsList';
import PartnersList from 'pages/Admin/Partners/PartnersList/PartnersList';
import PartnersTab from 'pages/GetCertified/Tabs/PartnersTab/PartnersTab';
import PlayerInformationTab from 'pages/Profile/Tabs/PlayerInformationTab/PlayerInformationTab';
import PlayerSettingsTab from 'pages/Profile/Tabs/PlayerSettingsTab/PlayerSettingsTab';
import PrivacyPolicyPage from 'pages/Policies/PrivacyPolicyPage/PrivacyPolicyPage';
import Profile from 'pages/Profile/Profile';
import ProgressTab from 'pages/Organization/Tabs/ProgressTab/ProgressTab';
import PurchaseMembershipPage from 'pages/GoPremium/PurchaseMembershipPage/PurchaseMembershipPage';
import StudentsTab from 'pages/Organization/Tabs/StudentsTab/StudentsTab';
import StudyCoursesList from 'pages/Admin/StudyCourses/StudyCoursesList/StudyCoursesList';
import StudyLessonsList from 'pages/Admin/StudyLessons/StudyLessonsList/StudyLessonsList';
import SubscriptionsTab from 'pages/Profile/Tabs/SubscriptionsTab/SubscriptionsTab';
import TermsAndConditionsPage from 'pages/Policies/TermsAndConditionsPage/TermsAndConditionsPage';
import TestInvitations from 'pages/Admin/TestInvitations/TestInvitations';
import TourAverages from 'pages/Admin/TourAverages/TourAverages';
import TrackmanParametersList from 'pages/Admin/TrackmanParameters/TrackmanParametersList/TrackmanParametersList';
import TranslatorPage from 'pages/Admin/TranslatorPage/TranslatorPage';
import { TestOneTimePayments } from 'pages/Admin/TestOneTimePayments/TestOneTimePayments';
import {
  isLearningHubEnabledBasedOnLanguage,
  isSubscriptionsAndPricingEnabled,
} from 'utilities/enabledFeaturesHelper';
import { LearningHub } from 'pages/LearningHub/LearningHub';
import { Pricing } from 'pages/Pricing/Pricing';
import { ModuleDetailsPage } from 'pages/LearningHub/ModuleDetails/ModuleDetails';
import { ModuleLibrary } from 'pages/LearningHub/ModuleLibrary/ModuleLibrary';
import { ModuleList } from 'pages/Admin/Modules/ModuleList/ModuleList';
import { EditGeneral } from 'pages/Admin/Modules/EditGeneral/EditGeneral';
import { ModuleItem } from 'pages/Admin/Modules/ModuleItem/ModuleItem';
import { EditChapters } from 'pages/Admin/Modules/EditChapters/EditChapters';
import { EditCertifications } from 'pages/Admin/Modules/EditCertifications/EditCertifications';
import { LearningModule } from 'pages/LearningHub/LearningModule/LearningModule';
import { TrackmanEvents } from 'pages/TrackmanEvents/TrackmanEvents';
import { TrackmanParameters } from 'pages/TrackmanParameters/TrackmanParameters';
import { SubscriptionsAndPricing } from 'pages/SubscriptionsAndPricing/SubscriptionsAndPricing';
import { Cart } from 'pages/SubscriptionsAndPricing/Cart/Cart';
import { SubscriptionsAndPricingShop } from 'pages/SubscriptionsAndPricing/Shop/Shop';

export const CertificationsTabsRelativeRoutes = {
  AboutTrackmanCertification: 'AboutTrackmanCertification',
  ApplyForMaster: 'ApplyForMaster',
  Certificate: 'Certificate',
  Partners: 'Partners',
  Masters: 'Masters',
} as const;

export const LearningMaterialsRelativeRoutes = {
  LearningMaterialsItem: ':courseId/:lessonId',
} as const;

export const ProfileTabsRelativeRoutes = {
  PlayerInformation: 'PlayerInformation',
  PlayerSettings: 'PlayerSettings',
  BillingAndPayment: 'BillingAndPayment',
  Subscriptions: 'Subscriptions',
} as const;

export const OrganizationTabsRelativeRoutes = {
  Progress: 'Progress',
  Students: 'Students',
  Classes: 'Classes',
} as const;

export const AdminPagesRelativeRoutes = {
  ModuleList: 'ModuleList',
  ModuleItem: 'ModuleEditor',
  EditModuleItem: 'ModuleEditor/:moduleId',
  CourseList: 'Courses',
  CoursesEditor: 'CoursesEditor',
  EditCourseItem: 'CoursesEditor/:courseId',
  LessonList: 'Lessons',
  LessonEditor: 'LessonEditor',
  EditLessonItem: 'LessonEditor/:lessonId',
  StudyCoursesList: 'StudyCourses',
  StudyCoursesEditor: 'StudyCoursesEditor',
  EditStudyCourseItem: 'StudyCoursesEditor/:studyCourseId',
  StudyLessonsList: 'StudyLessons',
  StudyLessonsEditor: 'StudyLessonsEditor',
  EditStudyLessonItem: 'StudyLessonsEditor/:studyLessonId',
  LearningMaterialsList: 'LearningMaterials',
  LearningMaterialsEditor: 'LearningMaterialsEditor',
  EditLearningMaterialItem: 'LearningMaterialsEditor/:learningMaterialId',
  User: 'User',
  Translation: 'Translation',
  OrganizationsList: 'Organizations',
  OrganizationsEditor: 'OrganizationsEditor',
  EditOrganizationItem: 'OrganizationsEditor/:organizationId',
  TestInvitations: 'TestInvitations',
  TestOneTimePayments: 'TestOneTimePayments',
  TrackmanParametersList: 'TrackmanParameters',
  TrackmanParametersEditor: 'TrackmanParametersEditor',
  EditTrackmanParameter: 'TrackmanParametersEditor/:parameterId',
  PartnersList: 'Partners',
  PartnersEditor: 'PartnersEditor',
  EditParter: 'PartnersEditor/:partnerId',
  MastersList: 'Masters',
  MastersEditor: 'MastersEditor',
  EditMaster: 'MastersEditor/:masterId',
  TourAverages: 'TourAverages',
  EventsList: 'Events',
  EventEditor: 'EventEditor',
  EditEventItem: 'EventEditor/:eventId',
} as const;

export const LearningHubTabs = {
  Modules: 'Modules',
  LearningHubCertifications: 'Certifications',
};

export const LearningHubRelativeRoutes = {
  ...LearningHubTabs,
  ModuleDetails: 'LearningHub/Modules/:slug',
  LearningModule: 'LearningHub/Modules/:slug/Module',
} as const;

export const AdminModuleTabs = {
  EditGeneral: 'General',
  EditChapters: 'Chapters',
  EditCertifications: 'Certifications',
};

export const SubscriptionsAndPricingRelativeRoutes = {
  Cart: 'SubscriptionsAndPricing/Cart',
} as const;

export const AdminModuleRelativeRoutes = AdminModuleTabs;

export const DefaultRoutes = {
  LandingPage: '/',

  Home: '/Home',
  TrackmanParameters: '/TrackmanParameters',
  LearningHub: '/LearningHub',
  SubscriptionsAndPricing: '/SubscriptionsAndPricing',
  LearningMaterials: '/LearningMaterials',
  ModulesAndTests: '/ModulesAndTests',
  Certifications: '/Certifications',
  PurchaseMembership: '/PurchaseMembership',
  TrackmanEvents: '/TrackmanEvents',
  Organization: '/Organization',
  Admin: '/Admin',
  Profile: '/Profile',
  CookiePolicy: '/CookiePolicy',
  TermsAndConditions: '/TermsAndConditions',
  Pricing: '/Pricing',
  PrivacyPolicy: '/PrivacyPolicy',
  NotFound: '/NotFound',
  NoAccess: '/NoAccess',
  ModulesAndTestsItem: ':courseId/:lessonId',
  ...LearningMaterialsRelativeRoutes,
  ...CertificationsTabsRelativeRoutes,
  ...ProfileTabsRelativeRoutes,
  ...OrganizationTabsRelativeRoutes,
  ...AdminPagesRelativeRoutes,
  ...LearningHubRelativeRoutes,
  ...AdminModuleRelativeRoutes,
} as const;

export type DefaultRouteKey = keyof typeof DefaultRoutes;

const learningHubRoutes = (
  <>
    <Route
      path={DefaultRoutes.LearningHub}
      element={isLearningHubEnabledBasedOnLanguage ? <LearningHub /> : <Navigate to={DefaultRoutes.Home} />}
    >
      <Route index element={isLearningHubEnabledBasedOnLanguage ? <ModuleLibrary /> : <Navigate to={DefaultRoutes.Home} />} />
    </Route>
    <Route
      path={LearningHubRelativeRoutes.ModuleDetails}
      element={isLearningHubEnabledBasedOnLanguage ? <ModuleDetailsPage /> : <Navigate to={DefaultRoutes.Home} />}
    />
    <Route
      path={LearningHubRelativeRoutes.LearningModule}
      element={isLearningHubEnabledBasedOnLanguage ? <LearningModule /> : <Navigate to={DefaultRoutes.Home} />}
    />
    <Route
      path={DefaultRoutes.Pricing}
      element={isLearningHubEnabledBasedOnLanguage ? <Pricing /> : <Navigate to={DefaultRoutes.Home} />}
    />
  </>
);

const subscriptionsAndPricingRoutes = isSubscriptionsAndPricingEnabled ? (
  <>
    <Route path={DefaultRoutes.SubscriptionsAndPricing} element={<SubscriptionsAndPricing />}>
      <Route index element={<SubscriptionsAndPricingShop />} />
    </Route>
    <Route path={SubscriptionsAndPricingRelativeRoutes.Cart} element={<Cart />}></Route>
  </>
) : null;

const adminModuleRoutes = (
  <>
    <Route path={DefaultRoutes.ModuleItem} element={<ModuleItem />}>
      <Route index element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChapters />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertifications />} />
    </Route>
    <Route path={DefaultRoutes.EditModuleItem} element={<ModuleItem />}>
      <Route index element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChapters />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertifications />} />
    </Route>
  </>
);

export const routes = (
  <Routes>
    <Route index element={<LandingPage />} />
    <Route path={DefaultRoutes.LandingPage} element={<LandingPage />} />
    <Route path={DefaultRoutes.Home} element={<HomePage />} />
    {learningHubRoutes}
    {subscriptionsAndPricingRoutes}
    <Route
      path={DefaultRoutes.ModulesAndTests}
      element={!isLearningHubEnabledBasedOnLanguage ? <ModulesAndTests /> : <Navigate to={DefaultRoutes.Home} />}
    />
    <Route
      path={DefaultRoutes.ModulesAndTests + '/' + DefaultRoutes.ModulesAndTestsItem}
      element={!isLearningHubEnabledBasedOnLanguage ? <ModulesAndTestsItem /> : <Navigate to={DefaultRoutes.Home} />}
    />

    <Route path={DefaultRoutes.TrackmanParameters} element={<TrackmanParameters />} />

    <Route
      path={DefaultRoutes.LearningMaterials}
      element={!isLearningHubEnabledBasedOnLanguage ? <LearningMaterials /> : <Navigate to={DefaultRoutes.Home} />}
    />
    <Route
      path={DefaultRoutes.LearningMaterials + '/' + DefaultRoutes.LearningMaterialsItem}
      element={!isLearningHubEnabledBasedOnLanguage ? <LearningMaterialsLessonPage /> : <Navigate to={DefaultRoutes.Home} />}
    />
    <Route path={DefaultRoutes.Certifications} element={<GetCertified />}>
      <Route index element={<AboutTab />} />
      <Route path={DefaultRoutes.Certificate} element={<CertificateTab />} />
      <Route path={DefaultRoutes.AboutTrackmanCertification} element={<AboutTab />} />
      <Route path={DefaultRoutes.ApplyForMaster} element={<ApplyTab />} />
      <Route path={DefaultRoutes.Partners} element={<PartnersTab />} />
      <Route path={DefaultRoutes.Masters} element={<MastersTab />} />
    </Route>
    <Route path={DefaultRoutes.PurchaseMembership} element={<PurchaseMembershipPage />} />
    <Route path={DefaultRoutes.TrackmanEvents} element={<TrackmanEvents />} />
    <Route path={DefaultRoutes.Profile} element={<Profile />}>
      <Route index element={<PlayerInformationTab />} />
      <Route path={DefaultRoutes.PlayerInformation} element={<PlayerInformationTab />} />
      <Route path={DefaultRoutes.PlayerSettings} element={<PlayerSettingsTab />} />
      <Route path={DefaultRoutes.BillingAndPayment} element={<BillingAndPaymentTab />} />
      <Route path={DefaultRoutes.Subscriptions} element={<SubscriptionsTab />} />
    </Route>
    <Route path={DefaultRoutes.Organization} element={<Organization />}>
      <Route index element={<ProgressTab />} />
      <Route path={DefaultRoutes.Progress} element={<ProgressTab />} />
      <Route path={DefaultRoutes.Students} element={<StudentsTab />} />
      <Route path={DefaultRoutes.Classes} element={<ClassesTab />} />
    </Route>
    <Route path={DefaultRoutes.Admin}>
      <Route index element={<ModuleList />} />
      <Route path={DefaultRoutes.ModuleList} element={<ModuleList />} />
      {adminModuleRoutes}
      <Route path={DefaultRoutes.CourseList} element={<CourseList />} />
      <Route path={DefaultRoutes.CoursesEditor} element={<EditCourse />} />
      <Route path={DefaultRoutes.EditCourseItem} element={<EditCourse />} />
      <Route path={DefaultRoutes.LessonList} element={<LessonList />} />
      <Route path={DefaultRoutes.LessonEditor} element={<EditLesson />} />
      <Route path={DefaultRoutes.EditLessonItem} element={<EditLesson />} />
      <Route path={DefaultRoutes.OrganizationsList} element={<OrganizationsList />} />
      <Route path={DefaultRoutes.OrganizationsEditor} element={<EditOrganization />} />
      <Route path={DefaultRoutes.EditOrganizationItem} element={<EditOrganization />} />
      <Route path={DefaultRoutes.StudyCoursesList} element={<StudyCoursesList />} />
      <Route path={DefaultRoutes.StudyCoursesEditor} element={<EditStudyCourse />} />
      <Route path={DefaultRoutes.EditStudyCourseItem} element={<EditStudyCourse />} />
      <Route path={DefaultRoutes.StudyLessonsList} element={<StudyLessonsList />} />
      <Route path={DefaultRoutes.StudyLessonsEditor} element={<EditStudyLesson />} />
      <Route path={DefaultRoutes.EditStudyLessonItem} element={<EditStudyLesson />} />
      <Route path={DefaultRoutes.LearningMaterialsList} element={<LearningMaterialsList />} />
      <Route path={DefaultRoutes.LearningMaterialsEditor} element={<EditLearningMaterial />} />
      <Route path={DefaultRoutes.EditLearningMaterialItem} element={<EditLearningMaterial />} />
      <Route path={DefaultRoutes.TrackmanParametersList} element={<TrackmanParametersList />} />
      <Route path={DefaultRoutes.TrackmanParametersEditor} element={<EditTrackmanParameter />} />
      <Route path={DefaultRoutes.EditTrackmanParameter} element={<EditTrackmanParameter />} />
      <Route path={DefaultRoutes.User} element={<ManageUserData />} />
      <Route path={DefaultRoutes.Translation} element={<TranslatorPage />} />
      <Route path={DefaultRoutes.TestInvitations} element={<TestInvitations />} />
      <Route path={DefaultRoutes.TestOneTimePayments} element={<TestOneTimePayments />} />
      <Route path={DefaultRoutes.PartnersList} element={<PartnersList />} />
      <Route path={DefaultRoutes.PartnersEditor} element={<EditPartner />} />
      <Route path={DefaultRoutes.EditParter} element={<EditPartner />} />
      <Route path={DefaultRoutes.MastersList} element={<MastersList />} />
      <Route path={DefaultRoutes.MastersEditor} element={<EditMaster />} />
      <Route path={DefaultRoutes.EditMaster} element={<EditMaster />} />
      <Route path={DefaultRoutes.TourAverages} element={<TourAverages />} />
      <Route path={DefaultRoutes.EventsList} element={<EventsList />} />
      <Route path={DefaultRoutes.EventEditor} element={<EventEditor />} />
      <Route path={DefaultRoutes.EditEventItem} element={<EventEditor />} />
    </Route>
    <Route path={DefaultRoutes.Profile} element={<Profile />} />
    <Route path={DefaultRoutes.CookiePolicy} element={<CookiePolicyPage />} />
    <Route path={DefaultRoutes.TermsAndConditions} element={<TermsAndConditionsPage />} />
    <Route path={DefaultRoutes.PrivacyPolicy} element={<PrivacyPolicyPage />} />
    <Route path={DefaultRoutes.NoAccess} element={<NoAccess />} />
    <Route path={DefaultRoutes.NotFound} element={<NotFound />} />
    <Route path='*' element={<Navigate to={DefaultRoutes.NotFound} />} />
  </Routes>
);
